import { riskRatingConfiguration } from './RiskRating/configurations/RiskRating.configuration.js';
import { IRiskConfiguration } from './IRiskConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const riskConfiguration: IRiskConfiguration = {
	riskRating: riskRatingConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
